import { render, staticRenderFns } from "./user-fax-edit.vue?vue&type=template&id=3f41a4fe&"
import script from "./user-fax-edit.vue?vue&type=script&lang=js&"
export * from "./user-fax-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports